export default __webpack_public_path__ + "static/media/dirk-vandenbergh.554616d7.jpg";